import { render, staticRenderFns } from "./DefaultTestWall.vue?vue&type=template&id=766d3b04&scoped=true&"
import script from "./DefaultTestWall.vue?vue&type=script&lang=js&"
export * from "./DefaultTestWall.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTestWall.vue?vue&type=style&index=0&id=766d3b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d3b04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VHover,VImg})
